import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import Link from 'gatsby-link'

const IndexPage = () => (
  <div>
    <h1>Moin!</h1>
    <p>¯\_(ツ)_/¯</p>
    {/* <Link to="/page-2/">Go to page 2</Link> */}
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js